import { render, staticRenderFns } from "./aiReportsIndex.vue?vue&type=template&id=67dbb71b&"
import script from "./aiReportsIndex.vue?vue&type=script&lang=js&"
export * from "./aiReportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports